'use client';

import type { ReactNode } from 'react';

export type AdminColumn<T> = {
  key: string;
  header: string;
  render: (row: T) => ReactNode;
};

type Props<T> = {
  columns: AdminColumn<T>[];
  rows: T[];
  rowKey: (row: T) => string;
  loading?: boolean;
  error?: string | null;
  emptyMessage?: string;
  nextCursor?: string | null;
  onLoadMore?: () => void;
};

export function AdminDataTable<T>({
  columns,
  rows,
  rowKey,
  loading,
  error,
  emptyMessage = 'No rows.',
  nextCursor,
  onLoadMore,
}: Props<T>) {
  if (error) {
    return <p className="admin-console__error">{error}</p>;
  }

  return (
    <div className="admin-table-wrap">
      <table className="theme-table admin-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={rowKey(row)}>
              {columns.map((col) => (
                <td key={col.key}>{col.render(row)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {!loading && rows.length === 0 && <p className="text-muted">{emptyMessage}</p>}
      {loading && <p className="text-muted">Loading…</p>}
      {nextCursor && onLoadMore && (
        <button type="button" className="btn btn-ghost admin-table__more" onClick={onLoadMore}>
          Load more
        </button>
      )}
    </div>
  );
}
